import { REMOVE, REMOVE_SUCCEEDED, REMOVE_FAILED } from "../types"

export const remove = config => {
  return { type: REMOVE, config }
}

export const removeSuccess = (action, response) => {
  return {
    type: REMOVE_SUCCEEDED,
    action,
    response,
    config: action.config,
  }
}

export const removeError = (action, error) => {
  return { type: REMOVE_FAILED, action, error }
}
